/**
 * @typedef {Object} Identifier
 * @property {string} kind - The kind/category of the identifier
 * @property {any} value - The value of the identifier
 *
 * Retrieves the value of the first identifier object with the specified kind.
 * @param {Identifier[]} identifiers - An array of identifier objects.
 * @param {string} kind - The kind of identifier to search for.
 * @returns {any} The value of the first matching identifier, or undefined if no match is found.
 */
export const getIdentifierByKind = (identifiers, kind) => {
  if (!identifiers) return '';
  return identifiers.find((identifier) => identifier.kind === kind)?.value;
};

/**
 * @typedef {Object} Identifier
 * @property {string} kind - The kind/category of the identifier
 * @property {any} value - The value of the identifier
 * @property {string} display_name - The display name of the identifier
 * @property {Object} transfer_party - The transfer party of the identifier
 * @property {string} agency_name - The agency name of the identifier
 */
export const getIdentifierDisplayName = (identifier) => {
  return identifier.display_name || identifier.transfer_party?.business_name || identifier.agency_name;
};
